import React, { FC, useState } from 'react';
import { AuthUser } from '@dynamika-shared/types/auth';
import { Avatar } from '@components/Avatar/Avatar';
import {
  LogoutIcon,
  SwitchSpaceIcon,
  VerticalLogo,
} from '@dynamika-shared/ui/icons';
import { UserMenuIcons } from '@components/UserMenu/UserMenuIcons';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { Link } from 'react-router-dom';
import { routesPath } from '@router/routes';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';

type UserMenuPopupProps = {
  userName?: string;
  authUser?: AuthUser;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const UserMenuPopup: FC<UserMenuPopupProps> = ({
  userName,
  authUser,
  setShowModal,
}) => {
  const [showRolesModal, setShowRolesModal] = useState<boolean>(false);
  const switchIconClassName =
  'w-[18px] h-[18px] text-pastelBlue group-hover:text-honoluluBlue';
  
  return (
    <>
      <div
        className='bg-white rounded-lg px-2 py-1.5'
        data-testid='UserMenuPopup'
      >
        <div className='usersection flex py-1'>
          <Avatar
            userName={userName ?? ''}
            nameSeparator={' '}
            className='w-5 h-5'
          />

          <div className='mx-1.5 flex flex-col'>
            <TruncatedText
              text={userName}
              truncate
              tooltip
              className={'text-[16px] font-semibold text-black max-w-[25rem]'}
            />

            <TruncatedText
              text={authUser?.email}
              truncate
              tooltip
              className={'text-1216 text-black max-w-[25rem]'}
            />
          </div>
        </div>
        <div className='switchrolesection py-1 border-b'>
          {authUser?.selectedRole &&
            (authUser['dynamika7/user_metadata'].roles.length > 1 ? (
              <>
                <p className='text-1216 text-spanishGray  mt-1'>Switch Space</p>
                <Link to={routesPath.selectRole} className='flex w-full'>
                  <div className='flex rounded-2xl w-full my-1 items-center hover:bg-waterLightHover50 p-1 group text-black'>
                    <UserMenuIcons icon={authUser.selectedRole} />
                    <SwitchSpaceIcon className={switchIconClassName} />
                  </div>
                </Link>
              </>
            ) : (
              <div className='flex w-full cursor-not-allowed'>
                <div className='flex rounded-2xl w-full m-1 items-center hover:bg-waterLightHover50 p-1 group text-black pointer-events-none'>
                  <UserMenuIcons icon={authUser.selectedRole} />
                  {authUser['dynamika7/user_metadata'].roles.length > 1 && (
                    <SwitchSpaceIcon className={switchIconClassName} />
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className='Logoutsection p-1 mt-1 hover:bg-waterLightHover50 rounded-2xl '>
          <div
            className='flex items-center cursor-pointer'
            onClick={() => setShowModal(true)}
          >
            <LogoutIcon className='w-2 h-2 mr-1' />
            <p className='text-1424 font-medium'>Log Out</p>
          </div>
        </div>
      </div>
      <Modal
        width={440}
        onCancel={async () => {
          setShowRolesModal(false);
        }}
        footer={null}
        open={showRolesModal}
        classNames={{
          header: '!mb-8 mt-3',
          content: 'text-center !rounded-[2.4rem] !p-[4rem] ',
          footer: 'flex justify-between !mt-3',
        }}
        title={
          <div className='flex flex-col h-full w-full items-center justify-center'>
            <VerticalLogo className='mb-6 mt-3 min-h-[92px] min-w-[92px]' />
            <h2 className=' text-[24px] leading-[32px] font-semibold text-black'>
              Select Preferred Workspace
            </h2>
            <p className='text-spanishGray text-1824 font-medium'>
              Select <span className='text-vividTangelo'>Space</span> you want
              to use{' '}
            </p>
          </div>
        }
      />
    </>
  );
};
